import PDFModal from "../PDFModal";
import HomepageCardButton from "../atoms/HomepageCardButton";
import React, {useState} from "react";
import styled, {css, useTheme} from "styled-components";
import HomepageTypeIcon from "../atoms/HomepageTypeIcon";
import {typologies} from "../organisms/HomepageCard";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import __ from "../../utils/translator";
import ManualStoreActions from "../../flux/ManualStoreActions";
import ThronModal from "../ThronModal";

export default function HomepageCardManualsList({
  parentId = null,
  manuals = []
}) {
  const appTheme = useTheme();
  const [selectedManualAsset, setSelectedManualAsset] = useState(null);
  const maxElementsNumber = manuals.length > 3 ? 2 : 3;

  return (
    <>
      <ManualList>
        {manuals.slice(0, maxElementsNumber).map((manual) => (
          <HomepageCardButton
            key={manual.id}
            onClick={(event) => {
              event.stopPropagation();
              setSelectedManualAsset(manual);
              return false;
            }}
          >
            <HomepageTypeIcon name={typologies.merchandisingManual} />
            <span>{manual.name}</span>
          </HomepageCardButton>
        ))}
        {manuals.length - maxElementsNumber > 0 && (
          <HomepageCardButton>
            <span>+{manuals.length - maxElementsNumber} {__('more')}</span>
          </HomepageCardButton>
        )}
      </ManualList>

      {selectedManualAsset !== null && (
        /*<PDFModal
          isMobile={appTheme.isMobile}
          asset={selectedManualAsset}
          onCloseButtonClick={() => setSelectedManualAsset(null)}
          onPdfLoad={() => {
            ManualStoreActions.manualLoad(selectedManualAsset.id, parentId)
          }}
        />*/
        <ThronModal asset={selectedManualAsset} onCloseButtonClick={() => setSelectedManualAsset(null)}/>
      )}
    </>
  );
}

const ManualList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: .25rem;
  padding: ${themeResponsiveProperty('.5rem 1.25rem 1.25rem', '.5rem 1rem 1rem')};

  svg {
    height: 1rem;
    color: #FFF;
  }

  span {
    font-size: .8125rem;
    line-height: 1.125rem;
    color: #FFF;
  }
`;
